<template>
    <el-dialog :append-to-body='true' :visible.sync="dialogVisible" width="40%">
        <div v-loading="loading">
            <p v-if="" style="margin-bottom: 0.05rem;font-size: 0.22rem">
                {{stockDetail.productNameCn ? stockDetail.productNameCn : stockDetail.productNameEn}}
            </p>
            <p style="margin-bottom: 0.2rem;color: #134247;font-size: 0.25rem">
                {{cancelTypeMap[stockDetail.cancelType] ? cancelTypeMap[stockDetail.cancelType] : '有条件退'}}
            </p>
                <div style="font-size: 0.16rem;line-height: 0.3rem;margin-bottom: 0.2rem" v-for="(items,indexs) in policyDetail" :key="indexs">
                    <p style="color: #134247;font-weight: bold;font-size: 0.2rem">
                        {{items.name}}
                    </p>
                    <p v-for="(item,index) in items.value" :key="index">
                        <span style="color: #58595B;font-weight: bold">{{item.name}}：</span>
                        <span>{{item.value}}</span>
                    </p>
                </div>
        </div>
    </el-dialog>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
    data() {
        return {
            dialogVisible:false,
            policyDetail:[],
            loading:false,
            stockDetail: {},
            cancelTypeMap:{
                1:'不可取消',
                5:'随时退',
                6:'过期退',
            }
        }
    },
    methods: {
        openDialog(stockId,stockDetail,type = 1) {
            this.stockDetail = stockDetail
            this.dialogVisible = true
            this.getPolicy(stockId,type)
        },
        getPolicy(id,type = 1) {
            this.loading = true
            new Api('resource').policyDetails(id,type).then(res => {
                if (res.status === 200) {
                    console.log(res.data)
                    this.policyDetail = res.data
                    this.loading = false
                }else {
                    this.$message.error(res.statusText)
                    this.loading = false
                }
            }).catch(err=>{
                this.loading = false
                this.$message.error('加载失败！')
            })
        }
    }
}
</script>
<style scoped lang="scss">

</style>